<script setup>
import { computed } from 'vue';
import { DIVIDER_SHAPES } from './dividers';

const props = defineProps({
    spec: { type: Object, default: () => ({}) },
});

const def = computed(() => DIVIDER_SHAPES[props.spec.shape] || null);

const transform = computed(() => {
    const sx = props.spec.flip_x ? -1 : 1;
    const sy = props.spec.flip_y ? -1 : 1;
    return `scale(${sx}, ${sy})`;
});

const height = computed(() => {
    const override = Number(props.spec.height);
    return Number.isFinite(override) && override > 0 ? override : (def.value?.height || 80);
});

const color = computed(() => props.spec.color || '#ffffff');
// `bg` paints the area BEHIND the SVG fills — i.e. the part of the
// divider that shows through the un-filled portions of each path.
// Defaults to transparent so existing dividers keep working; setting
// it to the block-above's background colour eliminates the
// hairline mismatch you'd otherwise see at the seam.
const bg = computed(() => props.spec.bg || 'transparent');
</script>

<template>
    <div v-if="def" class="tiq-divider" :style="{ height: height + 'px', backgroundColor: bg }">
        <svg :viewBox="def.viewBox" preserveAspectRatio="none" :style="{ transform }">
            <path v-for="(p, i) in def.paths" :key="i"
                  :d="p.d"
                  :fill="color"
                  :opacity="p.opacity ?? 1" />
        </svg>
    </div>
</template>

<style scoped>
.tiq-divider {
    display: block;
    line-height: 0;
    width: 100%;
    pointer-events: none;
}
.tiq-divider svg {
    display: block;
    width: 100%;
    height: 100%;
}
</style>
